import React from 'react';
import styled from 'styled-components';
const firstMedicalAppointmentImage =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/illustrations/doctor-initial-assessments.svg';
import Button from '../Button';
import ContainerModal from '../ContainerModal';

interface ModalModalSpecialistIntroductionProps {
  visible: boolean;
  onClose: () => void;
  buttonClosePrimary: () => void;
}

const Container = styled.div`
  flex-direction: column;
  align-items: center;
  color: #555658;
  text-align: center;

  h3 {
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    text-align: center;
    margin-top: 24px;
  }

  .info1 {
    color: #898b8e;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    margin-top: 24px;
  }

  @media (min-width: 900px) {
    justify-content: space-between;
  }
`;

const ModalSpecialistIntroduction: React.FC<ModalModalSpecialistIntroductionProps> = ({
  visible,
  onClose,
  buttonClosePrimary
}) => {
  return (
    <ContainerModal
      childrenFooter={<Button onClick={buttonClosePrimary} type="button" title="Continuar" />}
      visible={visible}
      onClose={onClose}
      headTitle=""
    >
      <Container>
        <img className="warn-image" src={firstMedicalAppointmentImage} alt="warning" />
        <h3>Temos novidade no agendamento de suas consultas!</h3>
        <p className="info1">Agora você pode agendar suas consultas utilizando convênio como forma de pagamento.</p>
        <p className="info1">
          Caso não possua plano de saúde, poderá realizar o pagamento de forma particular na unidade de atendimento
          selecionada.
        </p>
      </Container>
    </ContainerModal>
  );
};

export { ModalSpecialistIntroduction };
